export const SubMenuRoutes = {
  UserManagement: ["/users", "/users/usersdetailed"],
  ClientConfiguration: [
    "/display",
    "/emailapplylink",
    "/trackingpixels",
    "/trackingpixels/trackingpixeldetailed",
    "/externalaccounts",
    "/mastercache",
    "/banner",
    "/ancillary",
    "/prefilteredlinks",
  ],
  Search: ["/forms", "/eventsearch", "/mapconfiguration", "/customradius", "/results"],
  Jobs: [
    "/locations",
    "/locations/locationdetailed",
    "/featuredgroups",
    "/featuredgroups/featuredgroupsdetailed",
    "/featuredjobs",
    "/jobgroups",
    "/jobgroups/jobgroupdetailed",
  ],
  Events: [
    "/featuredevents",
    "/eventvenues",
    "/eventvenues/eventvenuedetailed",
    "/eventsponsors",
    "/eventsponsors/eventsponsordetailed",
    "/eventtypes",
    "/events",
    "/events/eventdetailed",
  ],
  Reports: ["/jobalertsreport", "/marketreport"],
  ABAC: ["/abac", "/abacClient", "/abacUser"],
  Profile: ["/profile"],
};
